export const SN_CATEGORY_REVIEW = 'categoryReview'
export const SET_LIST = SN_CATEGORY_REVIEW + '/SET_LIST'
export const RESET = SN_CATEGORY_REVIEW + '/RESET'
